module.exports = __webpack_public_path__ + "img/neo-tag-logo-dark.88e260aa.png";